module.exports = __webpack_public_path__ + "static/check-button.ccf89ed1312368be2b917a789a1ad36e.svg";